import { ref, reactive, onMounted, toRefs, computed } from '@vue/composition-api'
import api from '@/api/'

export default () => {
  const state = reactive({
    platformList: [], // 平台列表

    classifyList: [], // 分类列表
    authorList: [], // 发布者列表
    labelList: [], // 标签列表
  })

  onMounted(() => {
    methods.getPlatform()
  })

  const methods = {
    // 获取发布平台列表
    getPlatform: async function () {
      const res = await api.LineListNew()
      state.platformList = res.data
    }
  }

  return {
    ...toRefs(state),
    ...methods
  }
}
